<template>
  <div v-if="country.name && supportedCountry" class="quick-links">
    <div class="text-center">
      <span class="link-label">
         To see the best offers available in your current location:
      </span>
      <a :href="country.path" class="text-black">
        <img :alt="country.name + ' Flag'" :data-src="country.flag_verified"
            class="country-flag lazyload inline" height="16" width="16">
        <p class="title font-size-16 font-semibold inline">
          <span class="text-[#0157ff] hover:underline">
            Continue to {{ country.name }}
          </span>
        </p>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderQuickLinks",
  data() {
    return {
      time: '',
      links: [],
      country: {},
      supportedCountry: true,
    };
  },
  mounted() {
    this.fetchLinks();
  },
  methods: {
    visitorCountryCode() {
      if (!$('html').data('ipcountry')) {
        return 'gx';
      }
      return $('html').data('ipcountry').toLowerCase();
    },

    fetchLinks() {
      axios
      .get('/json-files/header-quick-links.json')
      .then((response) => {
        // find the country
        let visitorCountryCode = this.visitorCountryCode();

        // find the current country
        this.country = response.data['countries'].find(function (country) {
          return country['code'] === visitorCountryCode;
        }, visitorCountryCode);

        // when not found - we need to fallback to uk/gb
        if (!this.country) {
          this.supportedCountry = false;
          this.country = response.data['countries'].find(function (country) {
            return country['code'] === 'gb';
          });
        }

        this.links = this.country['links'];

        this.updateOptListCountry(this.country);
      })
      .catch((error) => {
        console.log('--------------- error ---------------');
      });
    },

    updateOptListCountry(country) {
      let countryBox = $('div[data-js="country-box"]');
      if (countryBox) {
        let countryName = country.name;
        let countryFlag = country.flag_verified;

        if (this.visitorCountryCode() === 'za') {
          countryName = 'South Africa';
          countryFlag = 'https://objects.kaxmedia.com/auto/o/107276/0b68181797.svg';
        }
        if (this.visitorCountryCode() === 'in') {
          countryName = 'India';
          countryFlag = 'https://objects.kaxmedia.com/auto/o/107273/0122188cd6.svg';
        }

        countryBox.find('[data-js="country-name"]').html(countryName);
        countryBox.find('img').attr('alt', countryName);
        countryBox.find('img').attr('src', countryFlag);
        const link = countryBox.find('.country-link');
        if (link) {
          link.attr('href', country.path);
        }
      }
    }
  }
};
</script>
